import { axiosInstance } from 'api/instance';
import { usersEndpoints } from './users.endpoints';

const getCurrentUser = body => {
  return axiosInstance.get(usersEndpoints.current, body);
};

const updateUser = data => {
  return axiosInstance.patch(usersEndpoints.current, data);
};

const changePassword = data => {
  return axiosInstance.post(usersEndpoints.password.change, data);
};

const forgotPassword = email => {
  return axiosInstance.post(usersEndpoints.password.forgot, email);
};

const confirmPassword = data => {
  return axiosInstance.post(usersEndpoints.password.confirm(data.uid, data.token), data);
};

const getUserCustomer = () => axiosInstance.get(usersEndpoints.customer);

const getUserToken = () => axiosInstance.get(usersEndpoints.userToken);

export const usersRequests = {
  getCurrentUser,
  updateUser,
  changePassword,
  forgotPassword,
  confirmPassword,
  getUserCustomer,
  getUserToken
};
